<template>
  <div class="CustomModel" v-if="show">
    <div class="TipsModel">
      <div class="TipsBox">
        <div class="header">
          <div class="title">
            <div>新固件版本说明</div>
            <div class="subTitle">{{ version }}</div>
          </div>
          <img
            @click="handleToClose"
            class="close"
            src="../../../assets/images/cancel.png"
            alt=""
          />
        </div>
        <div class="content">
          <div class="box" v-html="instrodution || '暂无说明'"></div>
          <div class="bockBg"></div>
        </div>

        <div class="footer">
          <div class="btn" @click="handleToClose">知道了</div>
        </div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<style scoped lang="less">
.CustomModel {
  position: relative;
  ::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    background-color: #f5f5f5;
    border-radius: 100px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 100px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background: #666;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

  .TipsModel {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2005;
    text-align: center;

    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }

    .TipsBox {
      background-color: #fff;
      width: 720px;
      height: 462px;
      z-index: 2005;
      display: inline-block;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 24px;
      font-size: 18px;
      text-align: left;
      overflow: hidden;
      backface-visibility: hidden;

      .header {
        width: 100%;
        padding: 42px 24px 16px 24px;
        position: relative;
        height: 122px;
        box-sizing: border-box;
        display: flex;

        .title {
          width: 100%;
          text-align: center;
          font-weight: 600;
          font-size: 24px;
          line-height: 32px;
          color: 000000;
          .subTitle {
            margin-top: 4px;
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
            color: #505050;
          }
        }

        img {
          width: 44px;
          height: 44px;
          position: absolute;
          top: 35px;
          right: 33px;
          cursor: pointer;
        }
      }

      .content {
        margin: 12px 0;
        padding: 4px 21px;
        position: relative;
        height: 204px;
        box-sizing: border-box;

        .bockBg {
          width: 100%;
          padding: 0 21px;
          box-sizing: border-box;
          height: 42px;
          position: absolute;
          left: 50%;
          bottom: -10px;
          transform: translateX(-50%);
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 82%
          );
          z-index: 333;
        }

        .box {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          font-size: 20px;
          text-align: justify;
          line-height: 28px;
          color: #505050;
          padding: 0px 21px;
          box-sizing: border-box;
        }

        a {
          color: #2d4fff;
        }

        p {
          margin: 0px;
          padding: 0px;
        }

        img,
        video {
          width: 100%;
          height: auto;
        }
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 42px 24px 24px;
        height: 112px;
        box-sizing: border-box;

        .btn {
          min-width: 124px;
          height: 54px;
          border-radius: 100px;
          padding: 16px 32px;
          box-sizing: border-box;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-weight: 600;
          color: #fff;
          background-color: #2417e4;
          cursor: pointer;

          &:hover {
            background-color: rgba(97, 122, 255, 1);
          }

          &:active {
            background-color: #243fcc;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
  }
}
</style>

<script>
export default {
  props: {
    show: Boolean,
    instrodution: String,
    version: String,
    onCancel: Function,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleToClose() {
      this.onCancel && this.onCancel();
    },
  },
};
</script>
